import { HttpRequest } from '@/utils/axios'
import { AxiosRequestConfig } from 'axios'
import { useCookies } from '@vueuse/integrations/useCookies'
import { Toast } from 'vant'
import { notification } from 'ant-design-vue'
import { agent, isUat } from '@/utils/tool'

const toast = (msg: string) => {
  if (agent) {
    Toast(msg)
  } else {
    notification.error({
      message: '错误',
      description: msg,
    })
  }
}

const cookies = useCookies()

const http = new HttpRequest({
  options: {
    baseURL: isUat ? '//uat-api.live.bilibili.com' : '//api.live.bilibili.com',
  },
  responseHook: (res) => {
    // 默认跳过/x/web-interface/nav返回的登录态
    if (res.data.code === -101 && res.request.responseURL.includes('/x/web-interface/nav')) {
      res.data.code = 0
    }
    if (res.data.code === 5006 && res.request.responseURL.includes('/audit/GetRoomInfo')) {
      res.data.code = 0
    }
  },
  notify: (msg: string) => {
    console.warn(msg, 'notify msg');
    // toast(msg)
  },
})

const $ajax = {
  get: async <T>(url: string, params?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => await http.get<T>(url, params, config),
  post: async <T>(url: string, params?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> =>
    await http.post<T>(url, { ...params, csrf: cookies.get('bili_jct'), csrf_token: cookies.get('bili_jct') }, config),
  form: async <T>(url: string, params?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => await http.form<T>(url, params, config),
}

export default $ajax
